import { render, staticRenderFns } from "./CourseOfInstructors.vue?vue&type=template&id=23d02468"
import script from "./CourseOfInstructors.vue?vue&type=script&lang=js"
export * from "./CourseOfInstructors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports